<i18n lang="yaml">
en:
  title: 'Contact information'
  spb: 'St. Petersburg'
  msk: 'Moscow'
  address1: '21&nbsp;Tsvetochnaya&nbsp;St., lit. A'
  address2: '36&nbsp;Berzarina&nbsp;St., building&nbsp;3'
ru:
  title: 'Контакты'
  spb: 'Санкт-Петербург'
  msk: 'Москва'
  address1: 'ул. Цветочная, д.&nbsp;21, лит. А'
  address2: 'ул. Берзарина, д.&nbsp;36, стр.&nbsp;3'
</i18n>

<template>
  <div class="contacts-widget">
    <nuxt-link
      class="contacts-widget__title"
      :to="{
        path: localePath(url.path ? `${url.path}` : ''),
        hash: url.hash ? `${url.hash}` : ''
      }"
      @click.native="$emit('closeMenu')"
    >
      <svg-marker class="contacts-widget__title-icon"></svg-marker>
      {{ $t('title') }}
    </nuxt-link>
    <address class="contacts-widget__address">
      <div class="contacts-widget__address-location">
        <span v-html="$t('spb')"></span>
        <span v-html="$t('address1')">}</span>
        <a href="tel:+78005550675">8 800 555 06 75</a>
      </div>
      <div class="contacts-widget__address-location">
        <span v-html="$t('msk')"></span>
        <span v-html="$t('address2')"></span>
        <a href="tel:+74956477980">+7 (495) 647-79-80</a>
      </div>
    </address>
    <div class="contacts-widget__social">
      <a
        v-for="(icon, key) in socialIcons"
        :key="key"
        class="contacts-widget__social-link"
        :href="icon.href"
        rel="noopener noreferrer"
        target="_blank"
      >
        <component :is="icon.componentName"></component>
      </a>
    </div>
  </div>
</template>

<script>
import SvgMarker from '~/assets/icons/header/dropdown-menu/marker.svg'
import SvgTelegram from '~/assets/icons/header/dropdown-menu/telegram.svg'
import SvgTwitter from '~/assets/icons/header/dropdown-menu/twitter.svg'
import SvgFb from '~/assets/icons/header/dropdown-menu/fb.svg'
import SvgVk from '~/assets/icons/header/dropdown-menu/vk.svg'
import SvgYouTube from '~/assets/icons/header/dropdown-menu/youtube.svg'

const socialIcons = [
  {
    href: 'https://t.me/SelectelNews',
    componentName: SvgTelegram
  },
  {
    href: 'https://twitter.com/selectel',
    componentName: SvgTwitter
  },
  {
    href: 'https://www.facebook.com/selectel/',
    componentName: SvgFb
  },
  {
    href: 'https://vk.com/selectel',
    componentName: SvgVk
  },
  {
    href: 'https://www.youtube.com/channel/UCVU0Ml1l_Y90wmy5EjWTSng',
    componentName: SvgYouTube
  }
]

export default {
  name: 'ContactsWidget',
  components: {
    SvgMarker,
    SvgTelegram,
    SvgTwitter,
    SvgFb,
    SvgVk
  },
  props: {
    externalTypeOfLink: {
      type: Boolean,
      default: false
    },
    url: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      socialIcons
    }
  }
}
</script>

<style lang="scss">

.contacts-widget {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 0 12px 24px;
  color: $primary65;
}

.contacts-widget__title {
  margin-bottom: 8px;
  color: $primary;
  transition: color 0.2s;

  &:hover {
    color: $secondary;

    .contacts-widget__title-icon {
      fill: $secondary;
    }
  }
}

.contacts-widget__title-icon {
  position: absolute;
  top: 12px;
  left: 0;
  display: block;
  width: 16px;
  max-height: 24px;
  margin: 4px 0;
  transition: fill 0.2s;
}

.contacts-widget__address {
  @include text--sm;

  a {
    color: inherit;

    &:hover {
      color: $secondary;
    }
  }
}

.contacts-widget__address-location {
  display: flex;
  flex-direction: column;

  &:not(:last-child) {
    margin-bottom: 16px;
  }
}

.contacts-widget__social {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
}

.contacts-widget__social-link {
  display: block;

  &:not(:last-child) {
    margin-right: 16px;
  }

  &:hover {
    svg {
      fill: $secondary;
    }
  }

  svg {
    fill: $primary30;
    transition: fill 0.2s;
  }
}
</style>